/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { type, validComps } from '../../utils';
import { $el, bind, getBooleanTypeAttr, getStrTypeAttr, removeAttrs, setHtml, siblings } from '../../dom-utils';
import PREFIX from '../prefix';
var Radio = /** @class */ (function () {
    function Radio() {
        this.VERSION = 'v1.0';
        this.COMPONENTS = $el('r-radio', { all: true });
        this._create(this.COMPONENTS);
    }
    Radio.prototype.config = function (el) {
        var target = $el(el);
        var isGroup = target.tagName.toLowerCase() == 'r-radio-group';
        // 排除 group 项
        if (!isGroup) {
            validComps(target, 'radio');
        }
        else {
            validComps(target, 'radio-group');
        }
        var _a = Radio.prototype, _isChecked = _a._isChecked, _isDisabled = _a._isDisabled, _setSingleChecked = _a._setSingleChecked, _setCurrentlyChecked = _a._setCurrentlyChecked;
        return {
            get checked() {
                return !isGroup && _isChecked(target);
            },
            set checked(newVal) {
                if (isGroup || !type.isBol(newVal))
                    return;
                _setSingleChecked(target, newVal);
            },
            get value() {
                // @ts-ignore
                return isGroup && target.getAttribute('value');
            },
            set value(newVal) {
                if (!isGroup && !type.isStr(newVal))
                    return;
                Array.from(target.children).forEach(function (child) {
                    var label = child.getAttribute('label');
                    _setCurrentlyChecked(child, newVal, label);
                });
            },
            events: function (_a) {
                var onChange = _a.onChange;
                if (!isGroup) {
                    bind(target, 'click', function () {
                        if (_isDisabled(target))
                            return false;
                        onChange && type.isFn(onChange, true);
                    });
                }
                else {
                    var data_1 = Object.create(null);
                    bind(target, 'click', function () {
                        Array.from(target.children).forEach(function (child, index) {
                            if (_isDisabled(child))
                                return false;
                            data_1['index'] = index;
                            data_1['label'] = child.getAttribute('label');
                            data_1['current'] = child;
                            if (_isChecked(child))
                                onChange && type.isFn(onChange, data_1);
                        });
                    });
                }
            }
        };
    };
    Radio.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            var _a = _this._attrs(node), checked = _a.checked, label = _a.label, icon = _a.icon, name = _a.name;
            var content = setHtml(node);
            var RadioGroupWrapper = _this._getGroupElm(node);
            if (RadioGroupWrapper) {
                var value = _this._attrs(RadioGroupWrapper).value;
                _this._setCurrentlyChecked(node, value, label);
            }
            _this._setMainTemplate(node, content, name);
            _this._setSingleChecked(node, checked, RadioGroupWrapper);
            _this._setIcon(node, icon);
            _this._handleClick(node, RadioGroupWrapper);
            removeAttrs(node, ['checked', 'icon']);
        });
    };
    Radio.prototype._setMainTemplate = function (node, content, name) {
        var template = "\n        <span class=\"" + PREFIX.radio + "\">\n          <span class=\"" + PREFIX.radio + "-inner\"></span>\n          <input type=\"radio\" name=\"" + name + "\" class=\"" + PREFIX.radio + "-input\" />\n        </span> " + content + "\n      ";
        setHtml(node, template);
    };
    // 设置单个radio选中
    Radio.prototype._setSingleChecked = function (node, checked, groupWrapper) {
        if (groupWrapper)
            return;
        checked
            ? node.classList.add(PREFIX.radio + "-checked")
            : node.classList.remove(PREFIX.radio + "-checked");
    };
    // 设置radio组的当前选中项
    Radio.prototype._setCurrentlyChecked = function (node, value, label) {
        if (value !== label)
            return;
        node.classList.add(PREFIX.radio + "-wrapper-checked");
        node.classList.add(PREFIX.radio + "-checked");
        siblings(node).forEach(function (o) {
            o.classList.remove(PREFIX.radio + "-wrapper-checked");
            o.classList.remove(PREFIX.radio + "-checked");
        });
    };
    Radio.prototype._setIcon = function (node, icon) {
        var _a;
        if (!icon)
            return;
        var template = "<i class=\"" + PREFIX.icon + " " + PREFIX.icon + "-" + icon + "\"></i>";
        (_a = node.querySelector("." + PREFIX.radio)) === null || _a === void 0 ? void 0 : _a.insertAdjacentHTML('afterend', template);
    };
    Radio.prototype._handleClick = function (node, groupWrapper) {
        var _this = this;
        if (this._isDisabled(node))
            return;
        var changeStatus = function () {
            if (groupWrapper) {
                node.classList.add(PREFIX.radio + "-wrapper-checked");
                siblings(node).forEach(function (o) {
                    if (_this._isChecked(o)) {
                        o.classList.remove(PREFIX.radio + "-checked");
                        o.classList.remove(PREFIX.radio + "-wrapper-checked");
                        o.classList.remove(PREFIX.radio + "-focus");
                    }
                });
            }
            node.classList.add(PREFIX.radio + "-checked");
        };
        bind(node, 'click', function () { return changeStatus(); });
        bind(node, 'mousedown', function () {
            node.classList.add(PREFIX.radio + "-focus");
        });
        bind(node, 'mouseup', function () {
            setTimeout(function () { return node.classList.remove(PREFIX.radio + "-focus"); }, 1000);
        });
    };
    Radio.prototype._getGroupElm = function (node) {
        var tag = node.parentElement;
        return (tag === null || tag === void 0 ? void 0 : tag.tagName.toLowerCase()) === 'r-radio-group' ? tag : null;
    };
    Radio.prototype._isDisabled = function (node) {
        return node.getAttribute('disabled') == '' || node.getAttribute('disabled') == 'true';
    };
    Radio.prototype._isChecked = function (node) {
        return node.classList.contains(PREFIX.radio + "-checked");
    };
    Radio.prototype._attrs = function (node) {
        return {
            value: getStrTypeAttr(node, 'value', ''),
            name: getStrTypeAttr(node, 'name', ''),
            label: getStrTypeAttr(node, 'label', ''),
            icon: getStrTypeAttr(node, 'icon', ''),
            checked: getBooleanTypeAttr(node, 'checked')
        };
    };
    return Radio;
}());
export default Radio;
